var _excluded = ["value", "onChange", "allowClear", "displayFormat", "valueFormat", "start", "end", "readOnly", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */
import { DatePicker as AntdDatePicker } from 'antd';
import cx from 'classnames';
import dayjs from 'dayjs';
import React, { useRef } from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { genDatePickerStyles } from "./styles";
import { Text } from "../Text";
export var DatePicker = wrapReactionHook(function (props) {
  var value = props.value,
    _onChange = props.onChange,
    allowClear = props.allowClear,
    _props$displayFormat = props.displayFormat,
    displayFormat = _props$displayFormat === void 0 ? 'YYYY-MM-DD' : _props$displayFormat,
    _props$valueFormat = props.valueFormat,
    valueFormat = _props$valueFormat === void 0 ? 'YYYY-MM-DD HH:mm:ss' : _props$valueFormat,
    start = props.start,
    end = props.end,
    readOnly = props.readOnly,
    disabled = props.disabled,
    rest = _objectWithoutProperties(props, _excluded);

  // displayFormat是空字符串时候时候不能格式化的问题
  var newDisplayFormat = displayFormat || 'YYYY-MM-DD';
  var newValueFormat = valueFormat || 'YYYY-MM-DD HH:mm:ss';

  // start 不能大于 end，否则start = undefined， end = undefined
  var startGtEnd = start && end && dayjs(start).isAfter(dayjs(end)); // start > end
  var newStart = startGtEnd ? undefined : start && dayjs(start).isValid() // 自身不合法
  ? start : undefined;
  var newEnd = startGtEnd ? undefined : end && dayjs(end).isValid() // 自身不合法
  ? end : undefined;
  var prefix = 'form-date-picker';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genDatePickerStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;

  // 用户当前选择的值，并不是最终的值（比如用户选择了day，但是还没有选择时分秒）
  var currentSelectedValue = useRef(value ? dayjs(value) : undefined);
  var range = function range(start, end) {
    var result = [];
    for (var i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };
  var disabledDateTime = function disabledDateTime() {
    var _currentSelectedValue;
    // 获取当前选择的日期，精确到day
    var currentSelectedDate = (_currentSelectedValue = currentSelectedValue.current) === null || _currentSelectedValue === void 0 ? void 0 : _currentSelectedValue.format('YYYY-MM-DD');

    // 如果当前选择日期正好等于开始日期或者结束日期，那么就需要计算时分秒，进行disabled计算，需要通过start/end里面的时分秒来计算
    var startDate = newStart ? dayjs(newStart) : undefined;
    if (startDate && startDate.isValid() && currentSelectedDate === startDate.format('YYYY-MM-DD')) {
      var startHour = startDate.hour();
      var startMinute = startDate.minute();
      var startSecond = startDate.second();
      return {
        disabledHours: function disabledHours() {
          return range(0, 24).filter(function (hour) {
            return hour < startHour;
          });
        },
        disabledMinutes: function disabledMinutes(hour) {
          if (hour === startHour) {
            return range(0, 60).filter(function (minute) {
              return minute < startMinute;
            });
          }
          return [];
        },
        disabledSeconds: function disabledSeconds(hour, minute) {
          if (hour === startHour && minute === startMinute) {
            return range(0, 60).filter(function (second) {
              return second < startSecond;
            });
          }
          return [];
        }
      };
    }
    var endDate = newEnd ? dayjs(newEnd) : undefined;
    if (endDate && endDate.isValid() && currentSelectedDate === endDate.format('YYYY-MM-DD')) {
      var endHour = endDate.hour();
      var endMinute = endDate.minute();
      var endSecond = endDate.second();
      return {
        disabledHours: function disabledHours() {
          return range(0, 24).filter(function (hour) {
            return hour > endHour;
          });
        },
        disabledMinutes: function disabledMinutes(hour) {
          if (hour === endHour) {
            return range(0, 60).filter(function (minute) {
              return minute > endMinute;
            });
          }
          return [];
        },
        disabledSeconds: function disabledSeconds(hour, minute) {
          if (hour === endHour && minute === endMinute) {
            return range(0, 60).filter(function (second) {
              return second > endSecond;
            });
          }
          return [];
        }
      };
    }
  };
  var handlePickerValueChange = function handlePickerValueChange(date) {
    if (date) {
      currentSelectedValue.current = date;
    }
  };
  var timeRegex = /(?:.*?)(HH:mm:ss|HH:mm|HH)/;
  var showTimeMatch = newDisplayFormat.match(timeRegex);
  var showTime = showTimeMatch ? {
    format: showTimeMatch[1]
  } : false;
  if (readOnly) {
    return /*#__PURE__*/React.createElement(Text, null, value ? dayjs(value).format(newDisplayFormat) : '-');
  }
  return wrapSSR( /*#__PURE__*/React.createElement(AntdDatePicker, _extends({
    className: cx(prefix, hashId)
  }, rest, {
    showTime: showTime,
    disabledTime: disabledDateTime,
    format: newDisplayFormat,
    minDate: newStart ? dayjs(newStart, newDisplayFormat) : undefined,
    maxDate: newEnd ? dayjs(newEnd, newDisplayFormat) : undefined,
    disabled: disabled,
    value: value ? dayjs(value) : undefined,
    onChange: function onChange(event) {
      _onChange(event === null || event === void 0 ? void 0 : event.format(newValueFormat));
    },
    onPickerValueChange: function onPickerValueChange(date) {
      handlePickerValueChange(date);
    },
    allowClear: allowClear && !disabled
  })));
});